import { render, staticRenderFns } from "./Environment.vue?vue&type=template&id=0ca62094&scoped=true&"
import script from "./Environment.vue?vue&type=script&lang=js&"
export * from "./Environment.vue?vue&type=script&lang=js&"
import style0 from "./Environment.vue?vue&type=style&index=0&id=0ca62094&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca62094",
  null
  
)

export default component.exports